export const adminMessages = {
  'admin.btn.cancel': 'Cancel',
  'admin.btn.delete': 'Delete',
  'admin.btn.edit': 'Edit',
  'admin.btn.query': 'Search',
  'admin.btn.reset': 'Reset',
  'admin.btn.save': 'Save',
  'admin.category.col.actions': 'Actions',
  'admin.category.col.count': 'Products',
  'admin.category.col.name': 'Name',
  'admin.category.col.sort': 'Sort',
  'admin.category.col.status': 'Status',
  'admin.category.confirmDel': 'Delete this category?',
  'admin.category.empty': 'No categories',
  'admin.category.formAdd': 'New category',
  'admin.category.formEdit': 'Edit category',
  'admin.category.list': 'List',
  'admin.category.nameEnPh': 'English name',
  'admin.category.namePh': 'Name',
  'admin.category.save': 'Save category',
  'admin.category.sortPh': 'Sort',
  'admin.category.sub': 'Manage categories, sort and enabled flag',
  'admin.category.title': 'Categories',
  'admin.form.back': '← Back',
  'admin.form.basic': 'Basics',
  'admin.form.catPlaceholder': 'Select category',
  'admin.form.category': 'Category',
  'admin.form.cover': 'Cover image URL',
  'admin.form.coverPh': 'Paste image URL',
  'admin.form.descEnLabel': 'English description',
  'admin.form.descEnPh': 'Enter English description',
  'admin.form.descLabel': 'Description',
  'admin.form.descPh': 'Description, about 30–200 characters',
  'admin.form.display': 'Presentation',
  'admin.form.err.cat': 'Please select a category',
  'admin.form.err.name': 'Product name is required',
  'admin.form.err.price': 'Price must be greater than 0',
  'admin.form.err.sku': 'SKU is required',
  'admin.form.err.stock': 'Stock cannot be negative',
  'admin.form.name': 'Product name',
  'admin.form.nameEn': 'English name',
  'admin.form.nameEnPh': 'Enter English name',
  'admin.form.namePh': 'Enter product name',
  'admin.form.noPreview': 'No preview',
  'admin.form.offSaleNow': 'Keep off shelf',
  'admin.form.onSaleNow': 'List now',
  'admin.form.original': 'Original (¥)',
  'admin.form.price': 'Price (¥)',
  'admin.form.publish': 'Publish',
  'admin.form.salesTotal': 'Total sales',
  'admin.form.saveEdit': 'Save changes',
  'admin.form.saveFail': 'Save failed, try again later',
  'admin.form.saving': 'Saving...',
  'admin.form.shelfStatus': 'Listing status',
  'admin.form.shop': 'Shop',
  'admin.form.shopDefault': 'Default first shop',
  'admin.form.sku': 'SKU',
  'admin.form.skuPh': 'e.g. FRUIT-001',
  'admin.form.stock': 'Stock',
  'admin.form.sub': 'Manage listing, price, stock and cover image',
  'admin.form.titleCreate': 'New product',
  'admin.form.titleEdit': 'Edit product',
  'admin.inv.allStatus': 'All statuses',
  'admin.inv.badStock': 'Stock must be a non-negative number',
  'admin.inv.col.action': 'Action',
  'admin.inv.col.name': 'Product',
  'admin.inv.col.ratio': 'Fill %',
  'admin.inv.col.safe': 'Safety stock',
  'admin.inv.col.sales': 'Sales',
  'admin.inv.col.sku': 'SKU',
  'admin.inv.col.status': 'Status',
  'admin.inv.col.stock': 'Stock',
  'admin.inv.editStock': 'Edit stock',
  'admin.inv.empty': 'No matching records',
  'admin.inv.gotoWarn': 'View alerts',
  'admin.inv.loading': 'Loading inventory...',
  'admin.inv.normal': 'OK',
  'admin.inv.prompt': 'Stock for "{name}" (current: {stock})',
  'admin.inv.searchPh': 'Search name / SKU',
  'admin.inv.statusOk': 'OK',
  'admin.inv.statusWarn': 'Low stock',
  'admin.inv.sub': 'Stock health and quick stock updates',
  'admin.inv.title': 'Inventory',
  'admin.inv.updateFail': 'Update failed',
  'admin.inv.warnChip': '⚠ Low stock {n}',
  'admin.inv.warningOpt': 'Low stock',
  'admin.invw.badge': 'Alert',
  'admin.invw.curStock': 'Stock {n}',
  'admin.invw.empty': 'No low-stock items',
  'admin.invw.safeStock': 'Safety {n}',
  'admin.invw.skuLine': 'SKU: {sku}',
  'admin.invw.sub': 'Items below safety stock',
  'admin.invw.title': 'Stock alerts',
  'admin.msg.markRead': 'Mark read',
  'admin.msg.read': 'Read',
  'admin.msg.sub': 'Orders, inventory alerts and notices',
  'admin.msg.title': 'Messages',
  'admin.msg.unread': 'Unread',
  'admin.odetail.address': 'Address',
  'admin.odetail.baseTitle': 'Order info',
  'admin.odetail.col.name': 'Product',
  'admin.odetail.col.qty': 'Qty',
  'admin.odetail.col.sub': 'Subtotal',
  'admin.odetail.col.unit': 'Unit price',
  'admin.odetail.created': 'Created',
  'admin.odetail.itemsTitle': 'Line items',
  'admin.odetail.orderNo': 'Order no.',
  'admin.odetail.payTime': 'Paid at',
  'admin.odetail.phone': 'Phone',
  'admin.odetail.status': 'Status',
  'admin.odetail.total': 'Total',
  'admin.odetail.user': 'User',
  'admin.order.action.cancel': 'Cancel order',
  'admin.order.action.complete': 'Mark completed',
  'admin.order.action.markPaid': 'Mark paid',
  'admin.order.action.ship': 'Confirm shipped',
  'admin.order.col.actions': 'Actions',
  'admin.order.col.amount': 'Amount',
  'admin.order.col.created': 'Created',
  'admin.order.col.no': 'Order no.',
  'admin.order.col.status': 'Status',
  'admin.order.col.user': 'User',
  'admin.order.confirmUpdate': 'Update order "{orderNo}" to "{label}"?',
  'admin.order.empty': 'No matching orders',
  'admin.order.loading': 'Loading orders...',
  'admin.order.searchPh': 'Order no. / username (Enter)',
  'admin.order.status.cancelled': 'Cancelled',
  'admin.order.status.completed': 'Completed',
  'admin.order.status.pending_payment': 'Pending payment',
  'admin.order.status.pending_shipping': 'Pending shipment',
  'admin.order.status.shipped': 'Shipped',
  'admin.order.sub': 'View status, ship and advance workflow',
  'admin.order.title': 'Orders',
  'admin.order.viewDetail': 'View detail',
  'admin.pdetail.cat': 'Category',
  'admin.pdetail.loading': 'Loading product...',
  'admin.pdetail.orig': 'Original price',
  'admin.pdetail.price': 'Sale price',
  'admin.pdetail.sales': 'Total sales',
  'admin.pdetail.sku': 'SKU',
  'admin.pdetail.status': 'Status',
  'admin.pdetail.stock': 'Stock',
  'admin.pdetail.sub': 'Full info and listing status',
  'admin.pdetail.title': 'Product detail',
  'admin.pdetail.updated': 'Updated at',
  'admin.product.add': '+ New product',
  'admin.product.allCat': 'All categories',
  'admin.product.allStatus': 'All statuses',
  'admin.product.chipOff': 'Off shelf {n}',
  'admin.product.chipOn': 'On sale {n}',
  'admin.product.col.actions': 'Actions',
  'admin.product.col.cat': 'Category',
  'admin.product.col.code': 'Code',
  'admin.product.col.goods': 'Product',
  'admin.product.col.name': 'Name',
  'admin.product.col.price': 'Price',
  'admin.product.col.sales': 'Sales',
  'admin.product.col.sku': 'SKU',
  'admin.product.col.status': 'Status',
  'admin.product.col.stock': 'Stock',
  'admin.product.confirmDelete': 'Delete this product? This cannot be undone.',
  'admin.product.confirmToggle': 'Set "{name}" to {action}?',
  'admin.product.deleteFail': 'Delete failed',
  'admin.product.empty': 'No products match. Adjust filters or add a new one.',
  'admin.product.loading': 'Loading products...',
  'admin.product.maxPrice': 'Max ¥',
  'admin.product.minPrice': 'Min ¥',
  'admin.product.noDesc': 'No description',
  'admin.product.offChip': 'Off shelf',
  'admin.product.onSaleChip': 'On sale',
  'admin.product.opFail': 'Operation failed',
  'admin.product.panelTitle': 'Product list',
  'admin.product.searchPh': 'Search name / SKU (Enter)',
  'admin.product.sub': 'Manage listings, price, stock and status',
  'admin.product.title': 'Products',
  'admin.product.toggleOff': 'Delist',
  'admin.product.toggleOn': 'List',
  'admin.product.totalCount': '{n} items',
  'admin.product.viewDetail': 'Detail',
  'admin.profile.accountReadonly': 'Username (read-only)',
  'admin.profile.basic': 'Basic info',
  'admin.profile.displayName': 'Display name',
  'admin.profile.displayPh': 'Name / nickname',
  'admin.profile.email': 'Email',
  'admin.profile.err.display': 'Display name is required',
  'admin.profile.err.save': 'Save failed',
  'admin.profile.noName': 'No display name',
  'admin.profile.phone': 'Phone',
  'admin.profile.pwdBtn': 'Change password',
  'admin.profile.pwdConfirm': 'Confirm new password',
  'admin.profile.pwdDoing': 'Updating...',
  'admin.profile.pwdErrLen': 'New password at least 6 characters',
  'admin.profile.pwdErrMatch': 'Passwords do not match',
  'admin.profile.pwdErrOld': 'Enter current password',
  'admin.profile.pwdNew': 'New password',
  'admin.profile.pwdOk': '✓ Password updated',
  'admin.profile.pwdOld': 'Current password',
  'admin.profile.pwdPhConfirm': 'Repeat new password',
  'admin.profile.pwdPhNew': 'At least 6 characters',
  'admin.profile.pwdPhOld': 'Current password',
  'admin.profile.pwdTitle': 'Change password',
  'admin.profile.save': 'Save profile',
  'admin.profile.saved': '✓ Profile updated',
  'admin.profile.saving': 'Saving...',
  'admin.profile.sub': 'Display name, phone and email',
  'admin.profile.title': 'Profile',
  'admin.shop.col.actions': 'Actions',
  'admin.shop.col.count': 'Products',
  'admin.shop.col.name': 'Name',
  'admin.shop.col.status': 'Status',
  'admin.shop.delConfirm': 'Delete this shop? (Blocked if products are linked.)',
  'admin.shop.delFail': 'Delete failed',
  'admin.shop.empty': 'No shops',
  'admin.shop.formAdd': 'New shop',
  'admin.shop.formEdit': 'Edit shop',
  'admin.shop.list': 'Shop list',
  'admin.shop.loadFail': 'Failed to load shops',
  'admin.shop.nameRequired': 'Shop name is required',
  'admin.shop.open': 'Open',
  'admin.shop.ph.banner': 'Banner URL',
  'admin.shop.ph.desc': 'Description',
  'admin.shop.ph.descEn': 'English description',
  'admin.shop.ph.followers': 'Followers (demo)',
  'admin.shop.ph.logo': 'Logo URL',
  'admin.shop.ph.name': 'Shop name',
  'admin.shop.ph.nameEn': 'English shop name',
  'admin.shop.ph.reviews': 'Good reviews base (demo)',
  'admin.shop.ph.tagline': 'Tagline',
  'admin.shop.ph.taglineEn': 'English tagline',
  'admin.shop.rest': 'Closed',
  'admin.shop.saveFail': 'Save failed',
  'admin.shop.statusActive': 'Open',
  'admin.shop.statusOff': 'Closed',
  'admin.shop.sub': 'Shop profile, images and status (links to product shopId)',
  'admin.shop.title': 'Shops',
  'admin.status.disabled': 'Disabled',
  'admin.status.enabled': 'Enabled',
  'admin.status.off': 'Off shelf',
  'admin.status.on': 'On sale',
  'admin.user.col.contact': 'Contact',
  'admin.user.col.login': 'Last login',
  'admin.user.col.name': 'Name',
  'admin.user.col.roles': 'Roles',
  'admin.user.col.status': 'Status',
  'admin.user.col.user': 'Username',
  'admin.user.sub': 'Operator accounts and roles',
  'admin.user.title': 'Users',
  'dash.addProduct': 'New product',
  'dash.categoryShare': 'Share by category',
  'dash.hotMeta': '{sales} pcs · ¥{revenue}',
  'dash.hotTitle': 'Top 5 sellers',
  'dash.level.high': 'Urgent',
  'dash.level.low': 'Normal',
  'dash.level.medium': 'Attention',
  'dash.loadFail': 'Failed to load dashboard',
  'dash.loading': 'Loading dashboard…',
  'dash.refresh': 'Refresh',
  'dash.retry': 'Retry',
  'dash.stat.newProducts': 'New today',
  'dash.stat.newProductsUnit': 'SKUs',
  'dash.stat.onSale': 'On sale',
  'dash.stat.onSaleUnit': 'SKUs',
  'dash.stat.ordersUnit': 'orders',
  'dash.stat.sales': 'Sales today',
  'dash.stat.warning': 'Low stock alerts',
  'dash.stat.warningAction': 'Handle →',
  'dash.subtitle': 'Products, orders, inventory and sales at a glance',
  'dash.title': 'Overview',
  'dash.todoTitle': 'To-do',
  'dash.trendHint': 'Sales (¥)',
  'dash.trendTitle': 'Sales trend (7 days)',
  'dash.wanSuffix': '',
  'menu.category': 'Categories',
  'menu.dashboard': 'Dashboard',
  'menu.inventory': 'Inventory',
  'menu.inventoryList': 'Stock list',
  'menu.inventoryWarning': 'Low stock',
  'menu.message': 'Messages',
  'menu.order': 'Orders',
  'menu.orderList': 'Order list',
  'menu.permission': 'Access control',
  'menu.product': 'Products',
  'menu.productCreate': 'New product',
  'menu.productList': 'Product list',
  'menu.profile': 'My profile',
  'menu.roleList': 'Roles',
  'menu.shop': 'Shops',
  'menu.userList': 'Users',
  'perm.category.create': 'Categories: create',
  'perm.category.delete': 'Categories: delete',
  'perm.category.update': 'Categories: edit',
  'perm.category.view': 'Categories: view',
  'perm.inventory.update': 'Inventory: adjust',
  'perm.inventory.view': 'Inventory: view',
  'perm.inventory.warning': 'Inventory: alerts',
  'perm.message.view': 'Messages',
  'perm.order.update': 'Orders: process',
  'perm.order.view': 'Orders: view',
  'perm.product.create': 'Products: create',
  'perm.product.delete': 'Products: delete',
  'perm.product.update': 'Products: edit',
  'perm.product.view': 'Products: view',
  'perm.profile.view': 'Profile',
  'perm.role.view': 'Roles',
  'perm.shop.create': 'Shops: create',
  'perm.shop.delete': 'Shops: delete',
  'perm.shop.update': 'Shops: edit',
  'perm.shop.view': 'Shops: view',
  'perm.user.view': 'Users',
  'role.loadFail': 'Failed to load roles',
  'role.subtitle': 'Role scope and permission sets',
  'role.title': 'Roles',
};
